// Module Federation bootstrap pattern
// This allows shared dependencies to be loaded before the app
import('./bootstrap')

export {}
